/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  StringMatch,
  StringMatch$inboundSchema,
  StringMatch$Outbound,
  StringMatch$outboundSchema,
} from "./stringmatch.js";

/**
 * Matches on the request path.
 */
export type PathMatch = {
  /**
   * String matcher. Exactly one of `exact`, `prefix` or `regex` must be set.
   */
  path: StringMatch;
};

/** @internal */
export const PathMatch$inboundSchema: z.ZodType<
  PathMatch,
  z.ZodTypeDef,
  unknown
> = z.object({
  path: StringMatch$inboundSchema,
});
/** @internal */
export type PathMatch$Outbound = {
  path: StringMatch$Outbound;
};

/** @internal */
export const PathMatch$outboundSchema: z.ZodType<
  PathMatch$Outbound,
  z.ZodTypeDef,
  PathMatch
> = z.object({
  path: StringMatch$outboundSchema,
});

export function pathMatchToJSON(pathMatch: PathMatch): string {
  return JSON.stringify(PathMatch$outboundSchema.parse(pathMatch));
}
export function pathMatchFromJSON(
  jsonString: string,
): SafeParseResult<PathMatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => PathMatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'PathMatch' from JSON`,
  );
}
